/* Feature story — mobile "Read more" (Cravinbyandy).
   Opt-in per instance via section setting `mobile_read_more`. Truncates the body to a few
   lines on mobile with an accessible toggle. Progressive enhancement: if this script never
   runs (JS off / error), the button stays hidden and the full body shows — a truncation is
   never left with no way to expand. Desktop is untouched. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var toggles = document.querySelectorAll('[data-readmore-toggle]');
  if (!toggles.length) return;

  toggles.forEach(function (btn) {
    // The body is the button's immediately-preceding [data-readmore-body].
    var body = btn.previousElementSibling;
    while (body && !body.hasAttribute('data-readmore-body')) {
      body = body.previousElementSibling;
    }
    if (!body) return;

    var userExpanded = false;

    function setCollapsed(collapsed) {
      if (collapsed) {
        body.classList.add('is-collapsed');
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.classList.remove('is-collapsed');
        btn.textContent = 'Read less';
        btn.setAttribute('aria-expanded', 'true');
      }
    }

    function apply(matches) {
      if (matches) {
        btn.hidden = false;
        setCollapsed(!userExpanded);
      } else {
        // Desktop: always full text, no control.
        btn.hidden = true;
        body.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    btn.addEventListener('click', function () {
      userExpanded = btn.getAttribute('aria-expanded') !== 'true';
      setCollapsed(!userExpanded);
    });

    apply(mq.matches);
    // Safari <14 only supports the deprecated addListener.
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mq.addListener) {
      mq.addListener(function (e) { apply(e.matches); });
    }
  });
})();
